<script setup lang="ts">
defineProps<{ data: HeroFullMediaProps }>()
</script>

<template>
  <div class="text-neon-yellow relative h-svh w-full lg:h-screen">
    <CommonMedia
      :loading="'eager'"
      :sizes="'70vw'"
      :media="data.media"
      class="h-full w-full"
      :fill="'both'"
      :aspect="[4 / 5, 16 / 9]"
    />

    <div
      class="absolute z-1 grid h-full w-full grid-cols-1 max-xl:bottom-0 max-xl:max-h-2/3 max-xl:pb-20 xl:top-0 xl:h-full xl:grid-cols-[1fr_auto_1fr] xl:items-center"
    >
      <IconsN
        class="h-full max-w-1/4 max-xl:col-start-1 max-xl:row-start-1 xl:max-w-1/2"
        :class="data.icons ? 'opacity-100' : 'opacity-0'"
      />

      <div
        class="px-bleed flex h-fit flex-col items-center gap-7 max-xl:col-span-full max-xl:mt-auto xl:px-0"
      >
        <ElementsPortableTextWrapper class="max-w-lg text-center text-lg" :content="data.text" />
        <ElementsButton
          v-for="(link, index) in data.callToAction"
          :key="index"
          :link="link"
          class="before:bg-neon-yellow text-black"
        />
      </div>

      <IconsX
        class="ml-auto h-full max-w-1/4 max-xl:col-start-1 max-xl:row-start-1 xl:max-w-1/2"
        :class="data.icons ? 'opacity-100' : 'opacity-0'"
      />
    </div>
  </div>
</template>
